module.exports = __webpack_public_path__ + "static/media/aon.51f69bf5.png";